/**
 * Environment variable utilities compatible with both Next.js and Vite
 */

// Detect if we're in a Vite environment
const isVite = typeof import.meta !== 'undefined' && import.meta.env !== undefined;

// Get NODE_ENV equivalent
export const getNodeEnv = (): any => {
  if (isVite) {
    return import.meta.env.MODE || 'development';
  }
  // Fallback for Next.js or other environments

};

// Check if we're in development
export const isDev = (): boolean => {

  if (isVite) {
    return import.meta.env.DEV;
  }
  return getNodeEnv() === 'development';
};

// Check if we're in production
export const isProd = (): boolean => {
  if (isVite) {
    return import.meta.env.PROD;
  }
  return getNodeEnv() === 'production';
};

// Get environment variable (supports both VITE_ and NEXT_PUBLIC_ prefixes)
export const getEnvVar = (key: string, defaultValue: string = ''): any => {
  if (isVite) {
    // In Vite, use VITE_ prefix
    const viteKey = key.startsWith('VITE_') ? key : `VITE_${key}`;
    //@ts-ignore
    return import.meta.env?.[viteKey] || defaultValue;
  }

};

